module.exports = __webpack_public_path__ + "img/Cheer Megaphone81.48390ee5.jpg";